module.exports = __webpack_public_path__ + "static/media/centro_comercial_vinuela.26392cdd.png";